import styled from "styled-components";

import { iconAccordionUp, iconAccordionDown } from "assets/icons";

export const AccordionContainer = styled.div`
  .accordion {
    --bs-accordion-color: ${({ theme }) => theme.global.extraInfo.font.color};
    --bs-accordion-bg: ${({ theme }) => theme.button.bg.secondary};
    --bs-accordion-btn-color: ${({ theme }) =>
      theme.global.extraInfo.font.color};
    --bs-accordion-border-radius: 10px;
    --bs-accordion-inner-border-radius: 10px;
    --bs-accordion-border-color: ${({ theme }) => theme.button.bg.secondary};
    --bs-accordion-btn-active-icon: url("${iconAccordionUp}");
    --bs-accordion-btn-icon: url("${iconAccordionDown}");
    --bs-accordion-btn-icon-width: 30px;
    --bs-accordion-active-bg: ${({ theme }) => theme.button.bg.secondary};
    --bs-accordion-border-width: 0px;
    --bs-accordion-btn-focus-box-shadow: none;
    --bs-accordion-active-color: ${({ theme }) =>
      theme.global.extraInfo.font.color};

    .accordion-item {
      background: ${({ theme }) => theme.global.bg.quinary};
      margin-bottom: 14px;
      border-bottom: 1px solid ${({ theme }) => theme.card.border.primary};

      button {
        font-weight: 600;
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
      }

      .accordion-body {
        background: ${({ theme }) => theme.global.bg.quinary};
        font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_14};
        padding: 8px 10px;
      }
    }
  }
`;
